"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.h1 = exports.heading = exports.popup = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _SubmitArtPopup = require("@quixeltools/quixel-ui-library/dist/components/common/gallery/SubmitArtPopup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popup = exports.popup = (0, _glamor.css)({
  width: "100vw",
  padding: (0, _css.unitRem)(2) + " " + (0, _css.unitRem)(1),
  paddingBottom: (0, _css.unitRem)(3.5),

  background: _css.colors.medDarkGray3
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  width: _css.sizes.innerMaxWidthTighter,
  padding: (0, _css.unitRem)(2.166) + " " + (0, _css.unitRem)(3.33) + " " + (0, _css.unitRem)(3.5)
}));

var heading = exports.heading = (0, _glamor.css)({
  display: "block",
  position: "relative",
  paddingLeft: 0,
  paddingTop: 0
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline-block",
  paddingLeft: "1.5rem"
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({}));

var h1 = exports.h1 = (0, _glamor.css)({
  fontWeight: 700,
  fontSize: (0, _css.unitRem)(1.25),
  marginBottom: 0,
  marginTop: 0,
  textAlign: "center"
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.875,
    mediumLarge: [1.4, 1.875]
  }
}), (0, _css.minWidth)(_css.breakpoints.medium)({
  textAlign: "left"
}));

var paragraph = (0, _glamor.css)({
  color: _css.colors.gray,
  fontSize: (0, _css.unitRem)(0.75),
  marginBottom: (0, _css.unitRem)(1.5)
});

var body = (0, _glamor.css)({
  color: _css.colors.gray,
  fontSize: (0, _css.unitRem)(0.75),
  lineHeight: 1.5
});

var date = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(0.25),
  color: _css.colors.white
});

var submitButton = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(1),
  fontSize: "0.9375em !important"
});

var cancelButton = (0, _glamor.css)(submitButton, {
  marginLeft: 0

  // '& button': {
  //   paddingLeft: unitRem(1.75),
  //   paddingRight: unitRem(1.58),
  // },
});

var keepButton = (0, _glamor.css)(submitButton, {
  // '& button': {
  //   paddingLeft: unitRem(2.29),
  //   paddingRight: unitRem(2.08),
  // },
});

var foot = (0, _glamor.css)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",

  marginTop: (0, _css.unitRem)(2),
  color: _css.colors.gray
});

var CancelSubscriptionPopup = function CancelSubscriptionPopup(props) {
  return _react2.default.createElement(
    "section",
    { className: popup },
    _react2.default.createElement(
      "div",
      { className: _SubmitArtPopup.header },
      _react2.default.createElement("img", { src: props.icon, alt: "", className: _SubmitArtPopup.icon }),
      _react2.default.createElement(
        "div",
        { className: heading },
        _react2.default.createElement(
          "h1",
          { className: h1 },
          "Cancel Subscription"
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: body },
      props.license !== "educational" ? _react2.default.createElement(
        "p",
        { className: paragraph },
        "If you cancel, here is what will happen at the end of your billing period,",
        _react2.default.createElement(
          "span",
          { className: date },
          props.date + ":"
        ),
        _react2.default.createElement("br", null),
        _react2.default.createElement("br", null),
        "* You will stop receiving new Megascans points.",
        _react2.default.createElement("br", null),
        "* You will lose access to the free section on the Megascans library.",
        _react2.default.createElement("br", null),
        "* You will stop receiving your personalized monthly drop of bonus assets.",
        _react2.default.createElement("br", null),
        _react2.default.createElement("br", null),
        "You will continue to be able to use any leftover points in your plan, and continue to use Bridge and Mixer even after the end of your billing period."
      ) : _react2.default.createElement(
        "p",
        { className: paragraph },
        "If you cancel, here is what will happen at the end of your billing period,",
        _react2.default.createElement(
          "span",
          { className: date },
          props.date + ":"
        ),
        _react2.default.createElement("br", null),
        _react2.default.createElement("br", null),
        "* You will lose access to Megascans asset repository for Education.",
        _react2.default.createElement("br", null),
        "*You will lose access to 4x faster downloads and one-click exports in Quixel Bridge.",
        _react2.default.createElement("br", null),
        "* You will lose access to the free section on the Megascans library.",
        _react2.default.createElement("br", null),
        _react2.default.createElement("br", null),
        "You will continue to be able to use the Quixel Mixer Free Beta even after the end of your billing period."
      )
    ),
    _react2.default.createElement(
      "div",
      { className: foot },
      _react2.default.createElement(_Button2.default, {
        className: cancelButton,
        small: true,
        onClick: props.onCancelSubscriptionClick,
        label: "Cancel anyway",
        loading: props.cancelling
      }),
      _react2.default.createElement(_Button2.default, {
        className: keepButton,
        small: true,
        mode: "secondary",
        onClick: props.onKeepSubscriptionClick,
        label: "Keep my subscription"
      })
    )
  );
};

exports.default = CancelSubscriptionPopup;


//////////////////
// WEBPACK FOOTER
// ./src/components/CancelSubscription/CancelSubscription.jsx
// module id = 2840
// module chunks = 0